{
  "Approve": "승인",
  "DeleteReminder": "미리 알림 삭제",
  "DismissAlert": "닫기",
  "DismissReminder": "미리 알림 닫기",
  "Earlier": "이전",
  "EditReminder": "미리 알림 편집",
  "High": "높음",
  "MarkAllAsRead": "모두 읽음으로 표시",
  "Reject": "거부",
  "RemindMe15Min": "15분 후에 다시 알리기",
  "RemindMe5Min": "5분 후에 다시 알리기",
  "RemindMe60Min": "1시간 후에 다시 알리기",
  "RemindMeTomorrow": "내일 다시 알리기",
  "Snooze": "다시 알리기",
  "markAsRead": "읽음으로 표시",
  "markAsUnread": "읽지 않음으로 표시",
  "noNotifications": "Adobe 제품, 동료 사용자와의 공동 작업 및 기타 관련 업데이트에 대한 중요한 정보를 받게 됩니다.",
  "noNotificationsTitle": "알림이 여기에 표시됩니다."
}
